import BaseEntity from "./BaseEntity";
import GameState, { getXYindex } from "../state/gameState";
import Phaser from "phaser";
import { BOARD_SIZE, layerDepthDiff } from "../constants";
import { EntityKind, LazorToggle } from "../state/entityKinds";
import { Dir } from "./Player";

const getDirection = (dir: Dir): string => {
  if (dir === Dir.Right) {
    return "Right";
  }
  if (dir === Dir.Left) {
    return "Left";
  }
  if (dir === Dir.Up) {
    return "Up";
  }
  return "Down";
};

export default class LazorToggleEntity extends BaseEntity {
  private sprite: Phaser.GameObjects.Sprite;
  constructor(gameState: GameState, scene: Phaser.Scene, obj: LazorToggle) {
    super(gameState, scene);

    const { x, y } = obj;

    const entity: LazorToggle = {
      ...obj,
      kind: EntityKind.LazorToggle,
      id: this.id,
    };

    this.sprite = this.scene.add.sprite(
      x * BOARD_SIZE,
      y * BOARD_SIZE,
      "atlas",
      this.getFrameName(entity)
    );

    gameState.silentMutateGameState((state) => {
      this.idx = getXYindex(x, y);
      state.board[this.idx].push(entity);
    });
    this.sprite.setDepth(y + layerDepthDiff.LAZORTOGGLE);

    this.scene.events.on("update", this.update, this);

    this.scene.events.once("destroy", () => {
      this.scene.events.removeListener("update", this.update, this);
    });
  }

  getFrameName(entity: LazorToggle) {
    return `LazorToggle/LToggle_Up_${entity.isActive ? "On" : "Off"}`;
  }

  update() {
    const entity = this.entityImmutable as LazorToggle;
    if (this.sprite.frame.name !== this.getFrameName(entity)) {
      this.sprite.setFrame(this.getFrameName(entity));
    }
  }
}
